import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import ReactHtmlParser from 'react-html-parser';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactModal from 'react-modal';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class PasswordModal extends Component {
    constructor(props) {
	    super(props);
	    this.state = {
	      	password: ""
	    };
    }

    handleChange = (e) => {
        let value = e.target.value;
        let password = this.state.password;
        password = value;
        this.setState({ password });
    }

    submit = (e) => {
        this.props.checkPresalePassword(this.state.password, this.props.isPasswordOpenFromUrl);
        this.props.togglePassword();
        this.setState({password:''});
    }

    render() {
        return ( 
            <div>
                <ReactModal 
                    className="showtix-event__modal"
                    isOpen={this.props.isPasswordOpen}
                    role={
                        "dialog"
                    }
                >
                    <button className="showtix-modal__close" onClick={()=>this.props.togglePassword('close')} aria-label="Close the modal">&times;</button>
                    <h4 className="modal-title text-center">{strings.title}</h4>
                    {ReactHtmlParser(strings.description)}
                    <div className="showtix-form__group pt-2">
                        <label className="showtix-label" htmlFor="password">{strings.title}</label>
                        <div className="showtix-form__input">
                            <input
                                type="text"
                                className="showtix-input"
                                placeholder={strings.title}
                                id="password"
                                name="password"
                                value={this.state.password}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button 
                            className="showtix-button showtix-background__primary-1"
                            onClick={this.submit}
                            >{strings.submit}</button>  
                    </div>
                </ReactModal>
            </div>
        )
    }
}

export default PasswordModal;


// WEBPACK FOOTER //
// ./src/components/EventListing/PasswordModal/PasswordModal.js